<template>
    <div>
        <div>
            {{ hideEnvelopeConfirmationBody }}
        </div>
        <ul>
            <li
                v-for="attachment of attachments"
                v-bind:key="attachment">
                {{ attachment }}
            </li>
        </ul>
    </div>
</template>
<script>
    import Vuex from "vuex";
    import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "../i18n/eSignature.i18n";

    export default {
        props: {
            envelope: { type: Object, required: true }
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE),
            envelopeDefinition() {
                return this.envelope.Definition;
            },
            savedItems() {
                const allItems = Object.values(this.envelopeDefinition.Items);
                return allItems.filter((i) => i.TargetAttachmentDefinitionId);
            },
            attachments() {
                const names = [];

                for (const item of this.savedItems) {
                    this.appendAttachmentName(item.TargetAttachmentDefinitionId, names);
                }
                if (this.envelope.CertificateTargetAttachmentId) {
                    this.appendAttachmentName(this.envelopeDefinition.CertificateTargetAttachmentDefinitionId, names);
                }
                if (this.envelope.TargetAttachmentId) {
                    this.appendAttachmentName(this.envelopeDefinition.TargetAttachmentDefinitionId, names);
                }
                return names;
            },
            ...Vuex.mapGetters({
                attachmentFromId: PROJECT_TYPES.getters.attachmentFromId
            })
        },
        methods: {
            appendAttachmentName(attachmentDefinitionId, names) {
                const attachment = this.attachmentFromId(attachmentDefinitionId);
                if (attachment) {
                    names.push(attachment.AttachmentDefinitionName);
                }
            }
        }
    };
</script>
